import FilterSectionTitle from "./FilterSectionTitle.vue";
import WrapWithSection from "./WrapWithSection.vue";
export default {
  name: "EmptySection",
  components: {
    WrapWithSection,
    FilterSectionTitle
  },
  props: {
    // The list section title, e.g. "Brands".
    title: {
      type: String,
      default: ""
    },
    // The active search term. May be a string or the array of words emitted by SearchElement.
    keyword: {
      type: [String, Array],
      default: ""
    },
    searching: {
      type: Boolean,
      default: false
    },
    heightFromTop: {
      type: String,
      default: "0px"
    }
  },
  computed: {
    formattedKeyword() {
      return Array.isArray(this.keyword) ? this.keyword.join(", ") : this.keyword;
    }
  }
};